import { observer } from 'mobx-react-lite';
import { EntityPresentation } from 'src/components/EntityPresentation/EntityPresentation';
import { SettingsDocumentationTemplatesStore } from 'src/stores/SettingsStores/SettingsDocumentationTemplatesStore/SettingsDocumentationTemplatesStore';
import styled from 'styled-components';

export const DocumentTemplatesDetails = observer(() => {
    return (
        <StyledWrapper>
            <EntityPresentation
                store={SettingsDocumentationTemplatesStore}
                entityName="setting-document-templates"
            />
        </StyledWrapper>
    );
});

const StyledWrapper = styled.div`
    .secondary-text {
        a {
            color: #6e6e73 !important;
            white-space: nowrap;
            &:hover {
                color: var(--form-text-color) !important;
            }

            &::after {
                content: ', ';
                margin-right: 0.4rem;
            }
            &:last-child::after {
                content: '';
                margin-right: 0;
            }
        }
    }
`;
